// Modules
import React from 'react';
import cx from 'classnames';

const AlertMessage = (props) => {
    const { type, message, onClose } = props;

    return (
        <div
            className={cx('alert alert-dismissible', {
                'alert-danger': type === 'error',
                'alert-success': type === 'success',
                'alert-info': type !== 'success' && type !== 'error',
            })}>
            <i className={cx({ 'fa fa-exclamation-triangle': type === 'error', 'fa fa-check': type === 'success' })} />
            <p>{message}</p>
            <button type="button" className="close" data-dismiss="alert" aria-label="Close" onClick={onClose}>
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
    );
};

export default AlertMessage;
